var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "backer-center-section",
    {
      attrs: {
        title: _vm.Resources.BackerCenter.SectionUpdatesFeedHeader,
        "link-more": _vm.linkMore,
        "label-more": _vm.Resources.BackerCenter.ViewUpdateFeedLabel,
        "is-loading": _vm.isProcessing,
        "is-empty": !_vm.hasUpdates,
        "empty-title": _vm.Resources.BackerCenter.UpdatesFeedEmptyStateHeader,
        "empty-description":
          _vm.Resources.BackerCenter.UpdatesFeedEmptyStateParagraph,
        "data-qa": "backer-center:UpdatesFeedTabs",
      },
    },
    _vm._l(_vm.effectiveUpdates, function (update) {
      return _c(
        "backer-center-update-feed-preview",
        _vm._b(
          { key: update.projectUpdateID },
          "backer-center-update-feed-preview",
          update,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }